export default function isPositiveNumber(value: number): boolean {
  return typeof value === "number" && !isNaN(value) && value >= 0;
}
